// const API_BASE_URL = 'http://202.21.38.118:82/';
const API_BASE_URL = 'https://adhityacrackers.com/api/';
// const API_BASE_URL = 'https://srigokilaacrackers.com/api/';
export default API_BASE_URL;
